<template>
  <div>
    <div id="ndg" class="post bg-blue">
      <div class="image">
        <video autoplay playsinline loop src="@/assets/2026/ndg3.mp4" style="height: 100%; width: 100%; object-fit: cover;" />
      </div>
      <div class="post-content-wrapper">
        <div class="post-header">Nordland Defence Group (NDG)</div>
        <pre class="post-content">
          Following the political breakdown and loss of central command, remaining elements of Nordland’s armed forces reorganized under a unified structure. The Nordland Defence Group operates independently but maintains allegiance to the nation and its lawful principles. With communication and logistics disrupted, NDG units continue to perform their duties - maintaining security, order, and control in the absence of civilian authority.

          The NDG functions as a disciplined military organization focused on the defense of key infrastructure, logistics routes, and state assets. Command adheres to military law and the Geneva Convention. Operations are conducted with precision, restraint, and accountability. The NDG considers itself the last legitimate military force within Nordland.

          Current operational orders designate the Riksbank Gold Reserve as a strategic national asset. Intelligence confirms that hostile formations, including the Mercenaries, are preparing a coordinated assault during the regional election period. Reinforcements are coming, but local command is authorized to defend the area and hold the vaults at all costs.

          <i>For Order and Nation.</i>
        </pre>
      </div>
    </div>

    <div id="commander" class="post">
      <div class="image">
        <img src="@/assets/commander.jpg" alt="Commander" />
      </div>
      <pre class="post-content-wrapper">
        <div class="post-header">Commander</div>
        <div class="post-content">
          To be announced
        </div>
      </pre>
    </div>

    <div class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Quick links</div>
        <div class="post-content">
          <ul class="quicklinks">
            <li><a href="#infantry">Infantry</a></li>
            <li><a href="#lmru">Light Mechanized Reconnaissance Unit (LMRU)</a></li>
            <li><a href="#mechanized">Mechanized Unit</a></li>
            <li><a href="#mpd">Military Police Detachment (MPD)</a></li>
            <li><a href="#ranger">Ranger & reconnaissance unit</a></li>
            <li><a href="#combat-medic">Combat Medic Unit (CMU)</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div id="infantry" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Infantry</div>

        <pre class="post-content">
          The <b>Nordland Defence Group Infantry</b> is the main combat force of the Blue Team. Trained for general combat, they carry out patrols, secure objectives, and support other units in coordinated operations. Equipped with standard military gear, they operate in urban and rural areas, maintaining control over assigned zones. The unit focuses on attack, defense, discipline, and following orders to keep operations stable and organized.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">Infantry is a military specialization which engages in ground combat on foot.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 300 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">None (Players with vehicles should join a Mechanized unit)</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Blue</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">With player Number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">Marpat, Digital Woodland, Cadpat, Vegetato, Multicam/MTP, AOR 2, Digital Flora, ATACS FG, M90, M98/M03, M84, M62, M05, M95, Multicam (both sides), OD (OD, OD-Gorka, RG, all sides), Pencott Green Zone/Pencott Wild Wood</td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action, Offensive, large firefights</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V power for battery charging, toilets, cold water showers and small kiosk with food for sale</td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use anti-tank weapons.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use light anti-tank weapons.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">Player armband (see rules for descriptions), uniform, combat gear (must look like a soldier)</td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">–</td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">No vehicles allowed. Players may not wear Ghillie or half-leaf suits.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="lmru" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Light Mechanized Reconnaissance Unit (LMRU)</div>
        <pre class="post-content">
          The Light Mechanized Reconnaissance Unit operates on the edge of the battlefield-fast, silent, and deadly. Equipped with ATVs, dirt bikes, and light buggies, they excel at high-speed scouting, target marking, and hit-and-run tactics in rugged terrain.

          Note: Players need to bring their own vehicles
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">Light Mechanized Recon units are fast, mobile forces equipped with ATVs, light
                vehicles, or buggies designed for reconnaissance and rapid response. They conduct scouting missions,
                support frontline operations, and provide intelligence on enemy movements while maintaining high
                mobility across all terrain.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 30 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">Players need to bring their own vehicles to play in this unit. Dirt bikes, ATVs or
                light buggies. Players must use a helmet when driving their vehicles.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Blue</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">With player Number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">Marpat, Digital Woodland, Cadpat, Vegetato, Multicam/MTP, AOR 2, Digital Flora,
                ATACS FG, M90, M98/M03, M84, M62, M05, M95, Multicam (both sides), OD (OD, OD-Gorka, RG, all sides),
                Pencott Green Zone/Pencott Wild Wood
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Low</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use anti-tank
                weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">In-game light offroad vehicles. Examples: dirt bike, atv or buggy. Cars, jeeps or
                SUVs are not allowed. Vehicles will not have hit receivers, players can be shot while riding their
                vehicle.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Players may not wear Ghillie or half-leaf suits</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="mechanized" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Mechanized Unit</div>
        <pre class="post-content">
          The Nordland Defence Group Mechanized Unit provides the Blue Team with mobility, protection, and firepower. Using armored vehicles, light transports, and all-terrain platforms, they move infantry, support operations, and secure key positions in urban and rural areas. Trained for coordinated movement and rapid response, the unit helps NDG forces reach objectives, react to threats, and maintain control while following orders and staying disciplined.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">Mechanized are infantry units equipped with armored personnel carriers (APCs) or
                infantry fighting vehicles (IFVs) for transport and combat.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 200 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">Class 1 - 5</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Blue</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player Number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">Marpat, Digital Woodland, Cadpat, Vegetato, Multicam/MTP, AOR 2, Digital Flora,
                ATACS FG, M90, M98/M03, M84, M62, M05, M95, Multicam (both sides), OD (OD, OD-Gorka, RG, all sides),
                Pencott Green Zone/Pencott Wild Wood
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action, mobile unit</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Low</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use anti-tank
                weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">In-game vehicle or a seat at a friend's vehicle. You may not book a ticket to this
                unit without a vehicle.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">Players in this unit who bring a vehicle must book a vehicle hit-receiver. Team
                color marking with number, will be received at vehicle check-in.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Players may not wear Ghillie or half-leaf suits. Car need small flag on top of the
                car to mark team color.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="mpd" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Military Police Detachment (MPD)</div>
        <pre class="post-content">
          Military Police Detachment upholds law and order within the operational zone. They police civilians, handle detainees, conduct interrogations, and manage prisoner facilities in base. The MPD also targets smuggling, searching vehicles, buildings, and convoys for contraband.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">The Military Police Detachment enforces law and order in the area of operations.
                They police civilians, handle detainees, and conduct searches for contraband in vehicles, buildings, and
                convoys. A few vehicles up to Class 1 are used for transport and patrol duties.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 50 players</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">Up to class 1, non armoured. Players who bring vehicles must book hit receivers.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Blue</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player number and extra blue armband with the white text "MP", included in ticket
                price.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">Marpat, Digital Woodland, Cadpat, Vegetato, Multicam/MTP, AOR 2, Digital Flora,
                ATACS FG, M90, M98/M03, M84, M62, M05, M95, Multicam (both sides), OD (OD, OD-Gorka, RG, all sides),
                Pencott Green Zone/Pencott Wild Wood
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Normal combat gear with an extra blue armband with the text "MP", included in the
                ticket.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms & assault rifles</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">LARP (Role playing)</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">Yes</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">No</td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">No</td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">Equipment for interrogation and documentation, handcuffs, flex-cuffs. Interrogation
                scripts, LARP drug testing equipment.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">BE provides Riot control agent (RCA) (orange smoke) to disperse crowds. A simple
                prison will be provided with cells and an interrogation room in base.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Players in this unit will interact with civilians and it is important that everyone
                has read the rules section regarding prisoners and confiscation of weapons.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="ranger" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Ranger & reconnaissance unit</div>
        <pre class="post-content">
          The Nordland Defence Group Rangers & Reconnaissance Unit is a light, mobile team tasked with scouting and gathering information. Operating across urban and rural areas, they locate enemy positions, monitor movements, and report back to support NDG operations. Equipped for mobility and self-sufficiency, they conduct patrols, reconnaissance and ambushing enemy units.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">A ranger unit operating behind enemy lines, reporting enemy positions, calling in
                mortar strikes, and ambushing enemy units or base location.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 100 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Blue</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">Marpat, Digital Woodland, Cadpat, Vegetato, Multicam/MTP, AOR 2, Digital Flora,
                ATACS FG, M90, M98/M03, M84, M62, M05, M95, Multicam (both sides), OD (OD, OD-Gorka, RG, all sides),
                Pencott Green Zone/Pencott Wild Wood
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear, Ghillie Suit or half-leaf suit</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">MILSIM players are expected to have good mental & physical strength and military
                service experience. Wildlife, hunting and hiking experience are also meritorious.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">High (Recommended minimum level Coopertest 2,3+ KM at 12 minutes or 40-44 vo2 max)
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers and small kiosk with food for sale. The unit
                must also operate self-sufficiently during parts of the game; small tents allowed for personal base.
                Fresh water will be provided at key objectives.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use anti-tank
                weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The blue team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">Personal gear to be self-sufficient during operations, players need to bring a large
                backpack to carry food, water and equipment during missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">The commander of this unit will receive a small extra supply of AT4s and mines to be
                used in missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Previous Berget experience or military service background required. No vehicles
                allowed. Players must wear Ghillie or half-leaf suits. Players must be able to operate without full
                Berget-events logistics support when deployed.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="combat-medic" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Combat Medic Unit (CMU)</div>
        <pre class="post-content">
          The Combat Medic Unit is a highly mobile small unit, built to operate in the heart of the conflict zone. Using military vehicles or ATVs with trailers to evacuate or treat wounded. CMU teams establish field hospitals (mobile respawns) .

          Critically injured players (dead that need base respawn) are transported back to base for further treatment, ensuring they receive the care needed to survive.

          Note: Must bring their own vehicles. 50 % of the players in this unit must be medics. While not in combat they evacuate dead players back to base or friendly respawn, but there is no guarantee that all players can be transported.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">The Combat Medic Unit provides frontline medical support using ATVs or light
                vehicles with trailers. They evacuate wounded, establish mobile field hospitals, and defend their
                positions under fire. Critically injured players are transported back to base for further treatment.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">20 players</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">Up to class 1, players who bring class 1 vehicles must book a hit-receiver when
                booking their ticket. All players must use a helmet when driving or riding in an open vehicle such as a
                dirt bike, ATV or buggy.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Blue</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player number and medic armband for the players who are medics.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">Marpat, Digital Woodland, Cadpat, Vegetato, Multicam/MTP, AOR 2, Digital Flora,
                ATACS FG, M90, M98/M03, M84, M62, M05, M95, Multicam (both sides), OD (OD, OD-Gorka, RG, all sides),
                Pencott Green Zone/Pencott Wild Wood
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms & assault rifles</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action & tactical support unit</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">No</td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">No</td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">Extra white rags for applying bandages.</td>
            </tr>
                      <tr>
                        <td class="label-col"><b>Team equipment provided by Berget</b></td>
                        <td class="value-col">Two field hospitals in large backpacks
          (Field hospital gives your team a respawn that can be placed anywhere on the map, used at the right moment this can give a huge advantage to your team)</td>
                      </tr>
                      <tr>
                        <td class="label-col"><b>Unit special requirements</b></td>
                        <td class="value-col">Must bring their own vehicles. 50 % of the players in this unit will be medics.</td>
                      </tr>
                    </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoalitionForces'
}
</script>

<style scoped>
b, .post-header, .label-col {
  color: #cfdbff;
}
@media (min-width: 921px) {
  video {
    margin-top: 88px;
  }
}
</style>
